import styled from 'styled-components';

interface WrapperProps {
    isBackToTopButtonShown: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    display: ${(props: WrapperProps): string => (props.isBackToTopButtonShown ? 'block' : 'none')};
    z-index: 1;
    opacity: ${(props: WrapperProps): string => (props.isBackToTopButtonShown ? '1' : '0')};
    transition: all $transition-time-fast ease-in;
    margin-top: 10px;
`;

export const Icon = styled.svg`
    fill: white;
    display: inline-block;
    width: 16px;
    height: 16px;
    color: #353535;
`;

export const RoundButton = styled.button`
    display: inline-block;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 100%;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #f7f7f7;
    background-color: #353535;
    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 5px 0;

    &:focus,
    &:hover {
        background-color: #4f4f4f;
        outline: none;
    }
`;
